import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-add",
  "use": "svgIcon-add-usage",
  "viewBox": "0 0 93.934 93.934",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 93.934 93.934\" id=\"svgIcon-add\"><path d=\"M46.967 0C21.028 0 0 21.028 0 46.967s21.028 46.967 46.967 46.967 46.967-21.027 46.967-46.967C93.934 21.028 72.906 0 46.967 0zm27.845 53.924H53.924v20.889H40.01V53.924H19.121V40.01H40.01V19.121h13.914V40.01h20.889v13.914z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol